import ApiClient from '@lib/apiClient';

import { downloadBlobFIle, printApiError } from '@utils/Util';

export const downTeckpackSummary = async (productIds) => {
	try {
		const body = { productIds };
		const response = await ApiClient.POST('downloadUserWiseReport', body);
		downloadBlobFIle(response);
	} catch (error) {
		printApiError(error);
	}
};

export const unmarkProductBlock = async (productId) => {
	try {
		const response = await ApiClient.DELETE('unmarkProductBlock', {}, `${productId}`);
		return response.data;
	} catch (error) {
		printApiError(error);
	}
};

export const downloadSketchImages = async (sketchId) => {
	try {
		const response = await ApiClient.GET_FILE_DATA('sketchAction', `${sketchId}/images/download`);
		return response;
	} catch (error) {
		printApiError(error);
	}
};

export const downloadSingleFile = async (docId) => {
	try {
		const response = await ApiClient.GET_FILE_DATA('downLoadSingleFile', `${docId}`);
		return response;
	} catch (error) {
		printApiError(error);
	}
};

export const uploadSingleImage = async (imageInfo) => {
	try {
		const response = await ApiClient.POST('uploadDocument', imageInfo);
		return response.data;
	} catch (error) {
		printApiError(error);
	}
};

export const uploadMultipleImage = async (images) => {
	try {
		const response = await ApiClient.POST('uploadBulkFiles', images);
		return response.data;
	} catch (error) {
		printApiError(error);
	}
};

export const removeSingleFile = async (docId, itemId) => {
	try {
		const apiUrl = itemId !== null ? `${docId}?sketchId=${itemId}` : `${docId}`;
		const response = await ApiClient.DELETE('removeDocFromSketch', {}, apiUrl);
		return response.data;
	} catch (error) {
		printApiError(error);
	}
};

export const getSketchResponse = async (sketchId) => {
	try {
		const { data } = await ApiClient.GET('sketchAction', sketchId);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const onAddSketch = async (body) => {
	try {
		const { data } = await ApiClient.POST('sketchAction', body, 'add');
		return data;
	} catch (error) {
		printApiError(error);
	}
};
export const onUpdateSketch = async (body, editId) => {
	try {
		const { data } = await ApiClient.PUT('sketchAction', body, editId);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const deleteSketch = async (sketchId) => {
	try {
		const response = await ApiClient.DELETE('sketchAction', {}, `${sketchId}`);
		return response.data;
	} catch (error) {
		printApiError(error);
	}
};

export const onAddArtwork = async (body) => {
	try {
		const { data } = await ApiClient.POST('artworkAction', body, 'add');
		return data;
	} catch (error) {
		printApiError(error);
	}
};
export const onUpdateArtwork = async (body, editId) => {
	try {
		const { data } = await ApiClient.PUT('artworkAction', body, editId);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const getArtworkResponse = async (artworkId) => {
	try {
		const { data } = await ApiClient.GET('artworkAction', artworkId);
		return data;
	} catch (error) {
		printApiError(error);
	}
};

export const deleteArtwork = async (artworkId) => {
	try {
		const response = await ApiClient.DELETE('artworkAction', {}, `${artworkId}`);
		return response.data;
	} catch (error) {
		printApiError(error);
	}
};

export const downloadArtworkImages = async (artworkId) => {
	try {
		const response = await ApiClient.GET_FILE_DATA('artworkAction', `${artworkId}/images/download`);
		return response;
	} catch (error) {
		printApiError(error);
	}
};
